import type { ComponentProps } from 'react';

import { cn } from '@repo/lib/cn';

import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select/';

interface NumberSelectProps extends ComponentProps<typeof Select> {
  start: number;
  end: number;
  getLabel?: (num: number) => string;
  placeholder?: string;
  className?: string;
  size?: 'sm' | 'md';
}

export function NumberSelect(numberSelectProps: NumberSelectProps) {
  const { start, end, getLabel, placeholder, className, value, size = 'md', ...props } = numberSelectProps;

  const range: number[] = Array.from({ length: end - start + 1 }, (_, i) => start + i);

  return (
    <Select {...props} value={value}>
      <SelectTrigger size={size} className={cn('relative gap-1.5', className)}>
        <SelectValue placeholder={placeholder}>{value ? Number(value) : null}</SelectValue>
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          {range.map((num) => (
            <SelectItem key={num} value={String(num)}>
              {getLabel ? getLabel(num) : num}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
}
